import React, { useState } from "react";
import PropTypes from "prop-types";
import { useCurrentUser } from "APP_ROOT/hooks";
import { BUYER_CREDIT_PCT, SETTINGS } from "APP_ROOT/constants";
import { connect } from "react-redux";
import { defaultStoreLocation } from "APP_ROOT/hooks/useCurrentUser";
import Form from "./Form";
import styles from "../../styles";

function CreateOrder({ buyerCreditPct, close, onSubmit, part }) {
  const [company, setCompany] = useState(null);

  const currentUser = useCurrentUser();

  const initialValues = {
    buying_store_id: defaultStoreLocation(currentUser),
    buyer_id: currentUser.id,
    buyer_credit_pct: buyerCreditPct,
    persistPart: true
  };

  return (
    <div className="panel panel-default" style={styles.container}>
      <div className="panel-body">
        <button className="close" type="button" onClick={close}>
          <span>
            <i className="fa fa-close" />
          </span>
        </button>
        <h4 className="modal-title" style={styles.title}>
          Create a New Purchase Order
        </h4>
        <Form
          close={close}
          initialValues={initialValues}
          onSubmit={onSubmit}
          part={part}
          selectedBuyer={currentUser}
          company={company}
          setCompany={setCompany}
        />
      </div>
    </div>
  );
}

CreateOrder.propTypes = {
  buyerCreditPct: PropTypes.number,
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  part: PropTypes.shape({})
};

export default connect(state => ({
  buyerCreditPct: state.session.getIn([SETTINGS, BUYER_CREDIT_PCT])
}))(CreateOrder);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/PurchaseOrders/Create/CreateOrder.jsx